import { useSelector } from 'react-redux';
import {
  getAlgoListDataCachedSelectedDay,
  getAlgoListDataCacheUpdateTime,
  getSorting,
} from '../stores/algos-list/getters';
import { getAlgosTableColumnToggleUpdateTime } from '../stores/algos-list-table-settings/getters';
import useBrokerDataAll from './useBrokerDataAll';
import { sortingConditional } from '../helpers/algo-list/sorting';

function useAlgosData() {
  const algos = useSelector(getAlgoListDataCachedSelectedDay);
  const sorting = useSelector(getSorting);
  const brokersDataAll = useBrokerDataAll();
  const algosSorted = sortingConditional(algos, sorting, brokersDataAll);
  // eslint-disable-next-line no-unused-vars
  const updateTime = useSelector(getAlgoListDataCacheUpdateTime);
  // eslint-disable-next-line no-unused-vars
  const algosTableColumnToggleUpdateTime = useSelector(
    getAlgosTableColumnToggleUpdateTime
  );

  return algosSorted;
}

export default useAlgosData;
